export default "__VITE_ASSET__7974fee0__"